import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=20063e4e&scoped=true&"
import script from "./Tile.vue?vue&type=script&lang=ts&"
export * from "./Tile.vue?vue&type=script&lang=ts&"
import style0 from "./Tile.vue?vue&type=style&index=0&id=20063e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20063e4e",
  null
  
)

export default component.exports